<div class="pages-modal confirm-input-data-modal ui-fluid">
    <form #form="ngForm" class="app-form-flex" novalidate="true">
        <div class="content">
            <div class="w-100">
                <p-messages *ngIf="!isModalOpened"></p-messages>
            </div>
            <div class="grid grid-cols-12 pd-3 gap-x-4 gap-y-1">
                <div class="col-span-12">
                    <span class="message">{{model?.message}}</span>
                </div>
                
                <div class="col-span-12">
                    <!-- Type Text -->
                    <ng-template [ngIf]="model.typeInput === 'TEXT'">
                        <app-input-field-validation id="text" [model]="text"
                            [label]="model.labelInput" [required]="true"
                            msg="messages.validation.inputRequired"
                            [paramsMsg]="{label: model.labelInput | translate}">
                            <input pInputText type="text" [(ngModel)]="model.value"
                                id="text" name="text" class="w-full"
                                app-input-uppercase [required]="true"
                                (onFocus)="selectAllTextWithDelay($event, 100)"
                                #text="ngModel" inputfield />
                        </app-input-field-validation>
                    </ng-template>
                    <!-- Type Number -->
                    <ng-template [ngIf]="model.typeInput === 'NUMBER'">
                        <app-input-field-validation id="number" [model]="number"
                            [label]="model.labelInput" [required]="true"
                            msg="messages.validation.inputRequired"
                            [paramsMsg]="{label: model.labelInput | translate}">
                            <input pInputText type="text" [(ngModel)]="model.value"
                                id="number" name="number" inputfield
                                app-input-numbers [required]="true"
                                (onFocus)="selectAllTextWithDelay($event, 100)"
                                class="w-full" #number="ngModel" />
                        </app-input-field-validation>
                    </ng-template>
                    <!-- Type Number Decimal -->
                    <ng-template [ngIf]="model.typeInput === 'DECIMAL'">
                        <app-input-field-validation id="numberDecimal" [model]="numberDecimal"
                            [label]="model.labelInput" [required]="true"
                            msg="messages.validation.inputRequired"
                            [paramsMsg]="{label: model.labelInput | translate}">
                            <p-inputNumber
                                id="numberDecimal" name="numberDecimal"
                                inputfield
                                [(ngModel)]="model.value"
                                [placeholder]="
                                    'placeholders.inputs.decimal' | translate
                                "
                                [minFractionDigits]="2"
                                [maxFractionDigits]="4"
                                [locale]="'locale' | translate"
                                [required]="true"
                                class="text-right w-full"
                                step="0" #numberDecimal="ngModel">
                            </p-inputNumber>
                        </app-input-field-validation>
                    </ng-template>
                    <!-- Type Money -->
                    <ng-template [ngIf]="model.typeInput === 'MONEY'">
                        <app-input-field-validation id="money" [model]="money"
                            [label]="model.labelInput" [required]="true"
                            msg="messages.validation.inputRequired"
                            [paramsMsg]="{label: model.labelInput | translate}">
                            <p-inputNumber
                                id="money" name="money"
                                inputfield
                                [(ngModel)]="model.value"
                                [placeholder]="
                                    'placeholders.inputs.money' | translate
                                "
                                [prefix]="'labels.prefixMoney' | translate"
                                [minFractionDigits]="2"
                                [maxFractionDigits]="4"
                                [locale]="'locale' | translate"
                                [required]="true"
                                class="text-right w-full"
                                step="0" #money="ngModel">
                            </p-inputNumber>
                        </app-input-field-validation>
                    </ng-template>
                    <!-- Type Mask -->
                    <ng-template [ngIf]="model.typeInput === 'MASK'">
                        <app-input-field-validation id="mask" [model]="mask"
                            [label]="model.labelInput" [required]="true"
                            msg="messages.validation.inputRequired"
                            [paramsMsg]="{label: model.labelInput | translate}">
                            <p-inputMask type="tel" [(ngModel)]="model.value"
                                id="mask" name="mask" inputfield
                                [mask]="maskInput" [required]="true" class="w-full"
                                #mask="ngModel">
                            </p-inputMask>
                        </app-input-field-validation>
                    </ng-template>
                    <!-- Type Passwork -->
                    <ng-template [ngIf]="model.typeInput === 'PASSWORD'">
                        <app-input-field-validation id="password" [model]="password"
                            [label]="model.labelInput" [required]="true"
                            msg="messages.validation.inputRequired"
                            [paramsMsg]="{label: model.labelInput | translate}">
                            <p-password id="password" name="password" autocomplete="new-password" inputfield
                                [(ngModel)]="model.value" styleClass="w-full" fluid [toggleMask]="true"
                                [placeholder]="'placeholders.inputs.password' | translate"
                                [required]="true" #password="ngModel" [feedback]="false">
                            </p-password>
                        </app-input-field-validation>
                    </ng-template>
                    <!-- Type Select Options -->
                    <ng-template [ngIf]="model.typeInput === 'SELECT_OPTIONS'">
                        <app-input-field-validation id="dropdown" [label]="model.labelInput"
                            [required]="true" [model]="dropdown" msg="messages.validation.inputSelectRequired"
                            [paramsMsg]="{label: model.labelInput | translate}">
                            <p-select id="dropdown" name="dropdown"
                                [options]="options" inputfield
                                [filter]="true" filterMatchMode="contains"
                                [(ngModel)]="model.value" optionLabel="label"
                                optionValue="value" appendTo="body"
                                [emptyMessage]="'messages.warn.selectEmptyMessage' | translate"
                                [emptyFilterMessage]="'messages.warn.selectEmptyMessage' | translate"
                                [placeholder]="'placeholders.select' | translate"
                                [required]="true" styleClass="w-full">
                            </p-select>
                        </app-input-field-validation>
                    </ng-template>
                    <!-- Type Multi Select Options -->
                    <ng-template [ngIf]="model.typeInput === 'MULTI_SELECT_OPTIONS'">
                        <app-input-field-validation id="multi-select" [label]="model.labelInput"
                            [required]="true" [model]="multiSelect" msg="messages.validation.inputSelectRequired"
                            [paramsMsg]="{label: model.labelInput | translate}">
                            <p-multiSelect id="multi-select" name="multi-select" [options]="options"
                                inputfield styleClass="w-full" appendTo="body"
                                [(ngModel)]="model.value" optionLabel="label"
                                optionValue="value" [required]="true" display="chip"
                                [emptyMessage]="'messages.warn.selectEmptyMessage' | translate"
                                [emptyFilterMessage]="'messages.warn.selectEmptyMessage' | translate"
                                [placeholder]="'placeholders.select' | translate"
                                [selectedItemsLabel]="'placeholders.selectedItemsLabel' | translate"
                                [virtualScroll]="true" [virtualScrollItemSize]="43"
                                #multiSelect="ngModel">
                            </p-multiSelect>
                        </app-input-field-validation>
                    </ng-template>
                </div>
            </div>
        </div>

        <div class="footer">
            <app-buttons-action
                [isShowMessage]="form.invalid || !isValid()"
                [message]="'messages.error.requiredInputFieldsIsNull' | translate">
                <ng-container buttons-action-right>
                    <button type="button" pButton icon="pi pi-times" [label]="'buttons.fechar' | translate"
                        class="p-button-outlined" (click)="close()"
                        severity="danger" *ngIf="model.canCancel"></button>
                    <button type="button" pButton icon="pi pi-check" [label]="'buttons.confirmar' | translate"
                        [disabled]="form.invalid || !isValid()" (click)="confirm()"></button>
                </ng-container>
            </app-buttons-action>
        </div>
    </form>
</div>